export const SET_ORDER_HISTORY = 'SET_ORDER_HISTORY';
